import {Injectable, Injector} from "@angular/core";
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { EventsService }    from './core/services/events.service';
import { LanguageService }    from './core/services/language.service';
import { ToastrService } from "ngx-toastr";
import { Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';

import {
    EXPIRED_AUTH_TOKEN
}                         from './app.constants';

@Injectable()
export class interceptedHttp implements HttpInterceptor {

    constructor(private eventBus: EventsService,
                private toastr: ToastrService,
                private injector: Injector
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let req = request;
        return next.handle(req)
            .catch((err) => {
                if (err instanceof HttpErrorResponse && err.status === 401) {
                    this.eventBus.trigger(EXPIRED_AUTH_TOKEN);
                    req = req.clone({ headers: new HttpHeaders().delete('Authorization') });
                    const languageService = this.injector.get(LanguageService);
                    this.toastr.error(languageService.translate('MESSAGES.UNAUTHENTICATED_ERROR'), 'Error');
                    return next.handle(req);
                }
                return Observable.throw(err);
            });
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/http.interceptor.ts